// extracted by mini-css-extract-plugin
export default {"save-button":"save-button--5589ea","saveButton":"save-button--5589ea"};